export default "__VITE_ASSET__DdlPxVfN__"